// A cart holds one coffee tin plus one matcha tin: a matcha product's tin sits
// alongside the coffee tin rather than replacing it. Mirrors the Shopify theme.

export const FREE_MATCHA_TIN_SKU = "EMPTYTIN-MATCHA";

export const isMatchaLineItem = (lineItem) =>
  Boolean(lineItem.variant?.sku?.toUpperCase().includes("MATCHA"));

const hasTinChild = (lineItem) =>
  Boolean(lineItem.children?.find(({ type }) => type === "rule"));

// The line item whose tin the selector manages. With both kinds in the cart,
// that's the coffee product's.
export const findTinLineItem = (cart) => {
  const withTin = cart.products.filter(hasTinChild);

  return withTin.find((item) => !isMatchaLineItem(item)) || withTin[0];
};
